export default __webpack_public_path__ + "static/media/location-hover.d53cddda.svg";